import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AuthStocktakingNameRoute extends Route {
  @service store;
  model(params) {
    console.log('model stock.name');
    let parentModel = this.modelFor('auth.stocktaking');
    let theOne = this.store
      .peekAll('location')
      .filter((location) => location.name === params.name);

    console.log(theOne[0].id);
    if (theOne.length) {
      const location = theOne[0];
      return { location, stocktaking: parentModel.stocktaking };
    } else {
      return null;
    }
  }
}
